export default class HomepageStructure {
  constructor(type, productFocused) {
    this._type = type;
    this._productFocused = productFocused;
    this._leftSide = [];
    this._middleSectionWeb = [];
    this._middleSectionMobile = [];
    this._rightSide = [];
    this.checkForType();
  }

  /**
   * function to check which structure we have to use
   */
  checkForType() {
    switch (this._type) {
      case 'Prof':
        this.generateProfStructure();
        break;
      case 'Product':
      default:
        this.generateProductStructure();
        break;
    }
    this.setMiddleSectionForProductFocused();
  }

  generateProfStructure() {
    // left side
    this._leftSide = ['ActivityCalendarClassic', 'AppDownloadButtons'];
    // middle section web
    this._middleSectionWeb = [
      'UserFavourites',
      'AllCategories',
      // 'AllActivities',
    ];
    // middle section mobile
    this._middleSectionMobile = [
      // 'BannerTextBlock',
      'Benefits',
      'UserFavourites',
      'AppDownloadButtons',
      'AdditionalInfo',
    ];
    // right side
    this._rightSide = ['TrendingItems', 'AdditionalInfo'];
  }

  generateProductStructure() {
    // left side
    this._leftSide = ['ActivityCalendarClassic', 'AppDownloadButtons'];
    // middle section web
    this._middleSectionWeb = [
      'AllCategories',
      //'AllActivities',
      'UserFavourites',
      // 'BlogEvents',
      'TemplateEvents',
      'Reviews',
      'PartnerInformation',
      // 'UserDutchStamps',
    ];
    // middle section mobile
    this._middleSectionMobile = [
      // 'BannerTextBlock',
      'Benefits',
      'AppDownloadButtons',
      'AdditionalInfo',
      'UserFavourites',
      'BlogEvents',
      'TemplateEvents',
      'Reviews',
      'PartnerInformation',
      // 'UserDutchStamps',
    ];
    // right side
    this._rightSide = ['AdditionalInfo', 'TrendingItems'];
  }

  setMiddleSectionForProductFocused() {
    // set the indexes to change if the product focused
    const positionOfCategory = this._middleSectionWeb.indexOf('AllCategories');
    // const positionOfActivities =
    //   this._middleSectionWeb.indexOf('AllActivities');
    const positionOfCategoryMobile =
      this._middleSectionWeb.indexOf('AllCategories');
    // const positionOfActivitiesMobile =
    //   this._middleSectionWeb.indexOf('AllActivities');
    // set the components if the product focused is false
    if (!this._productFocused) {
      // this._middleSectionWeb[positionOfCategory] = 'AllActivities';
      // this._middleSectionWeb[positionOfCategoryMobile] = 'AllActivities';
      this._middleSectionWeb[positionOfActivities] = 'AllCategories';
      this._middleSectionWeb[positionOfActivitiesMobile] = 'AllCategories';
    }
  }

  get leftSide() {
    return this._leftSide;
  }

  get middleSectionWeb() {
    return this._middleSectionWeb;
  }

  get middleSectionMobile() {
    return this._middleSectionMobile;
  }

  get rightSide() {
    return this._rightSide;
  }
}
